import { useState, useEffect } from "react";
import Backend from "../utils/api.js";
import { summarizeSessions } from "../Dashboard/dashboardData.js";

export default function useDashboardData(user) {
  const [state, setState] = useState({ loading: true, error: null, data: null });

  useEffect(() => {
    const uid = user?.UID;
    if (!uid) return undefined;
    let cancelled = false;

    (async () => {
      const [activeRes, aggRes, permsRes, toolPermsRes, spacesRes, authRes, toolsRes] = await Promise.all([
        Backend.getUserSessions(uid, { status: "active" }),
        Backend.getUserSessions(uid, { perPage: 500 }),
        Backend.getLabPermissionsByUser(uid),
        Backend.getMachineTypesByUser(uid),
        Backend.getSpacesStatus(),
        Backend.checkBadgrAuthentication(uid),
        Backend.getTools(),
      ]);
      if (cancelled) return;

      const activeSession = (activeRes.items || [])[0] || null;
      const sessions = (aggRes.items || [])
        .slice()
        .sort((a, b) => new Date(b.startedAt) - new Date(a.startedAt));
      const spaceStatuses = spacesRes.items || [];
      const spaceNames = Object.fromEntries(spaceStatuses.map((s) => [s.id, s.name]));
      const toolNames = Object.fromEntries((toolsRes.items || []).map((t) => [t.id, t.name]));
      const certifiedToolIds = toolPermsRes.data || [];

      const managedSpaces = (permsRes.items || []).filter((p) => p.is_admin);
      setState({
        loading: false,
        error: null,
        data: {
          activeSession,
          stats: summarizeSessions(sessions),
          certifications: {
            count: certifiedToolIds.length,
            tools: certifiedToolIds.map((id) => ({ id, name: toolNames[id] || String(id) })),
            authenticated: !!toolPermsRes.authenticated,
          },
          badgeLinked: !!authRes.authenticated,
          recentVisits: sessions.slice(0, 8),
          spaceNames,
          managedSpaces,
          isAdmin: managedSpaces.length > 0 || !!user.isSuperAdmin,
        },
      });
    })().catch(() => {
      if (!cancelled) setState({ loading: false, error: "generic", data: null });
    });

    return () => {
      cancelled = true;
    };
  }, [user?.UID, user?.isSuperAdmin]);

  return state;
}
